import React, { Component } from "react";
import {
  MetaClub,
  MetaClubMensual,
  ProcesoResultado
} from "../../../../types/AnualidadMetaCarga";
import AnualidadMetaCarga from "../../../../types/AnualidadMetaCarga";
import { formatMoney } from "../../../helpers/formatters";

interface Props {
  metasClubes: MetaClub[];
  cargaInfo: AnualidadMetaCarga | null;
}

export default class ConfiguracionMetasTable extends Component<Props> {
  getRowStyle = (resultado: ProcesoResultado) => {
    switch (resultado) {
      case ProcesoResultado.ERROR:
        return { backgroundColor: "#f8d7da" };
      case ProcesoResultado.WARNING:
        return { backgroundColor: "#fffbdbff" };
      default:
        return {};
    }
  };

  renderMonthlyColumns = (metasMensuales: MetaClubMensual[]) => {
    if (!metasMensuales || metasMensuales.length === 0) {
      return null;
    }

    return metasMensuales.map((meta, idx) => (
      <td key={idx}>
        {meta && meta.metaAcumulada !== null
          ? formatMoney(meta.metaAcumulada, 2)
          : formatMoney(0, 2)}
      </td>
    ));
  };

  render() {
    const { metasClubes, cargaInfo } = this.props;

    if (!metasClubes || metasClubes.length === 0 || !cargaInfo) {
      return null;
    }

    const mesesHeaders = metasClubes[0].metasMensuales
      ? metasClubes[0].metasMensuales.map(m => m.mes)
      : [];

    return (
      <>
        <div className="mb-4">
          <div className="row mt-3">
            <div className="col-12">
              <h5 className="mb-3">
                <strong>Metas por Club</strong>
              </h5>
              <div className="table-responsive">
                <table className="table table-striped table-bordered table-sm">
                  <thead className="thead-dark">
                    <tr>
                      <th>Región</th>
                      <th>Clave</th>
                      <th>Club</th>
                      <th>Meta Acumulada</th>
                      {mesesHeaders.map(mes => (
                        <th key={mes}>{mes}</th>
                      ))}
                      <th>Mensaje</th>
                    </tr>
                  </thead>
                  <tbody>
                    {metasClubes.map((club, i) => (
                      <tr key={i} style={this.getRowStyle(club.resultado)}>
                        <td>
                          <strong>{club.numeroRegion || "-"}</strong>
                        </td>
                        <td>{club.claveClub}</td>
                        <td>{club.club}</td>
                        <td>
                          <strong>
                            {club && club.metaAcumulada !== null
                              ? formatMoney(club.metaAcumulada, 2)
                              : formatMoney(0, 2)}
                          </strong>
                        </td>
                        {this.renderMonthlyColumns(club.metasMensuales)}
                        <td>{club.mensaje || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
